import '../../assets/css/style.css';

import appLogo from "../../assets/svgs/logo.svg";
const goToHome = ()=>{
    document.location.href = '/'
}
const IntroLogo = ()=>{
    return(
        <div className="logo-container">
            <img onClick={goToHome} src={appLogo} alt="Logo" className="d-block" />
        </div>
    )
}
export default IntroLogo